<!--发布公告-->
<template>
<el-row>
    <el-col :span="24" style="padding:20px;">
        <el-form ref="form" :model="form" :rules="editFormRules" label-width="200px" style="width:100%;min-width:600px;">
            <el-form-item label="公告标题：" prop="title">
                <el-input type="text" maxlength="15" show-word-limit placeholder="请输入公告标题" v-model="form.title">
                </el-input>
            </el-form-item>
            <div style="margin: 20px 0;"></div>
            <el-form-item label="公告内容：" prop="content">
                <!-- <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 14}" placeholder="请输入公告内容" v-model="form.content">
                </el-input> -->
                <div ref="editorElem" style="text-align:left;"></div>
            </el-form-item>
            <el-form-item style="text-align:right;margin-top:20px;">
                <el-button type="primary" @click.native="clear">清空</el-button>
                <el-button type="primary" @click.native="save">保存</el-button>
            </el-form-item>
        </el-form>
    </el-col>
</el-row>
</template>

<script>
import util from '../../common/js/util';
import E from "wangeditor";
import {
    getNotice,
    saveNotice,
    delNotice
} from '../../api/api';

export default {
    data() {

        var validTitle = (rule, value, callback) => {
            if (value.length == 0) {
                callback(new Error('请输入公告标题'));
            } else if (value.length > 15) {
                callback(new Error('公告标题最大允许15个字'));
            } else {
                callback();
            }
        };
        var validContent = (rule, value, callback) => {
            if (value == '<p><br></p>' || value.length == 0) {
                callback(new Error('请输入公告内容'));
            } else if (value.length > 800) {
                callback(new Error('公告内容最大允许800个字'));
            } else {
                callback();
            }
        };

        return {
            form: {
                title: '',
                content: '',
                editor: null
            },
            editFormRules: {
                title: [{
                    required: true,
                    validator: validTitle,
                    trigger: 'blur'
                }],
                content: [{
                    required: true,
                    validator: validContent,
                    trigger: 'blur'
                }]
            }
        }
    },
    methods: {
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('确认发布此公告吗？', '提示', {}).then(() => {
                        let para = Object.assign({}, this.form);
                        saveNotice(para).then((res) => {
                            let {
                                msg,
                                code
                            } = res;
                            if (code !== 0) {
                                this.$message({
                                    message: "发布失败",
                                    type: 'error'
                                });
                            } else {
                                this.$message({
                                    message: '发布成功',
                                    type: 'success'
                                });
                                this.init();
                            }
                        });
                    });
                }
            });
        },
        clear() {
            this.$confirm('确认清空公告吗？', '提示', {}).then(() => {
                delNotice().then((res) => {
                    let {
                        msg,
                        code
                    } = res;
                    if (code !== 0) {
                        this.$message({
                            message: "清空失败",
                            type: 'error'
                        });
                    } else {
                        this.$message({
                            message: '公告已清除',
                            type: 'success'
                        });
                        this.init();
                    }
                });
            });

        },
        init() {
            getNotice().then((res) => {
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    this.$message({
                        message: "查询失败",
                        type: 'error'
                    });
                } else {
                    this.form = res.data;
                    this.editor.txt.html(this.form.content);
                }
            });
        }
    },
    mounted() {
        this.init();
        this.editor = new E(this.$refs.editorElem);
        this.editor.customConfig.zIndex = 100;
        this.editor.customConfig.onchange = (html) => {
            this.form.content = html;
        }
        this.editor.customConfig.onblur = (html) => {
            this.form.content = html;
            this.$refs.form.validate();
        }
        this.editor.create(); // 创建富文本实例
    }
}
</script>



// WEBPACK FOOTER //
// noticeManager.vue?adc3f65e